"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _initiateChatHelper = require("./../helpers/initiate-chat-helper");

var _get = _interopRequireDefault(require("lodash/get"));

var ChatContainer = function ChatContainer(props) {
  var isRetrieving = (0, _reactRedux.useSelector)(function (state) {
    return (0, _get["default"])(state, 'auth.retrieving');
  });
  var featureChat = (0, _reactRedux.useSelector)(function (state) {
    return (0, _get["default"])(state, 'auth.getFeaturesInfoResponse.chat') || !(0, _get["default"])(state, 'auth.isAuthenticated');
  });
  (0, _react.useEffect)(function () {
    if (featureChat && !isRetrieving) {
      (0, _initiateChatHelper.initiateChat)();
    }
  }, [featureChat, isRetrieving]);
  return null;
};

ChatContainer.propTypes = {
  featureChat: _propTypes["default"].bool
};

var _default = (0, _react.memo)(ChatContainer);

exports["default"] = _default;